export const FEATURE_FLAG_NAMES = Object.freeze({
  DISCUSSION_DRAWER_TOGGLE: "discussionDrawerToggle",
});

function parseFeatureFlag(value, defaultValue = false) {
  if (value == null || value === "") return defaultValue;
  const normalized = String(value).trim().toLowerCase();
  if (["1", "true", "yes", "on", "enabled"].includes(normalized)) return true;
  if (["0", "false", "no", "off", "disabled"].includes(normalized)) return false;
  return defaultValue;
}

export const FEATURE_FLAGS = Object.freeze({
  [FEATURE_FLAG_NAMES.DISCUSSION_DRAWER_TOGGLE]: parseFeatureFlag(
    process.env.NEXT_PUBLIC_FEATURE_DISCUSSION_DRAWER_TOGGLE,
    false
  ),
});

export function isFeatureEnabled(name) {
  return FEATURE_FLAGS[name] === true;
}

